// export default ProductMap = {
exports.ProductMap = {
  6: {
    '2 kWh': [{
      name: 'Get Set Kit (2kWh)',
      pid: '7293361455296',
      varId: '42914699706560',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '3498',
      old_price: '4398',
      save_money: '900',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (2kWh)',
      pid: '7293361455296',
      varId: '42914699739328',
      adaptBatCap: '2-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '3898',
      old_price: '4947',
      save_money: '1049',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (2kWh)',
      pid: '7293361455296',
      varId: '42914699772096',
      adaptBatCap: '2-1',
      limit: 2,
      off_price: '4198',
      old_price: '5247',
      save_money: '1049',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '4 kWh': [{
      name: 'Get Set Kit (4kWh)',
      pid: '7293361520832',
      varId: '42914699804864',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '4997',
      old_price: '6397',
      save_money: '1400',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (4kWh)',
      pid: '7293361520832',
      varId: '42914699837632',
      adaptBatCap: '2-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '5397',
      old_price: '6995',
      save_money: '1598',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (4kWh)',
      pid: '7293361520832',
      varId: '42914699870400',
      adaptBatCap: '2-1',
      limit: 1,
      off_price: '5697',
      old_price: '7295',
      save_money: '1598',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '5 kWh': [{
      name: 'Get Set Kit (5kWh)',
      pid: '7293361619136',
      varId: '42914700361920',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5298',
      old_price: '6598',
      save_money: '1300',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (5kWh)',
      pid: '7293361619136',
      varId: '42914700394688',
      adaptBatCap: '5-1',
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5698',
      old_price: '7147',
      save_money: '1449',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (5kWh)',
      pid: '7293361619136',
      varId: '42914700427456',
      adaptBatCap: '5-1',
      limit: 2,
      off_price: '5998',
      old_price: '7447',
      save_money: '1449',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '10 kWh': [{
      name: 'Get Set Kit (10kWh)',
      pid: '7293361750208',
      varId: '42914701508800',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '8597',
      old_price: '10797',
      save_money: '2200',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (10kWh)',
      pid: '7293361750208',
      varId: '42914701541568',
      adaptBatCap: '5-1',
      limit: 1,
      consoleChoose: 'Y',
      off_price: '8997',
      old_price: '11395',
      save_money: '2398',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (10kWh)',
      pid: '7293361750208',
      varId: '42914701574336',
      adaptBatCap: '5-1',
      limit: 1,
      off_price: '9297',
      old_price: '11695',
      save_money: '2398',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '15 kWh': [{
      name: 'Get Set Kit (15kWh)',
      pid: '7293361782976',
      varId: '42914701607104',
      consoleChoose: 'Y',
      off_price: '11896',
      old_price: '14996',
      save_money: '3100',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (15kWh)',
      pid: '7293361782976',
      varId: '42914701639872',
      consoleChoose: 'Y',
      off_price: '12296',
      old_price: '15643',
      save_money: '3347',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '3x Battery Mounting Strap'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (15kWh)',
      pid: '7293361782976',
      varId: '42914701672640',
      off_price: '12596',
      old_price: '15943',
      save_money: '3347',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Late August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '3x Battery Mounting Strap'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }]
  }
};
exports.solarPanelMap = {
  6: [{
    name: '2*100W Rigid Solar Panel+2*Rigid solar mounting feet',
    pid: '7293361979584',
    varId: '42914702819520',
    old_price: '209',
    off_price: '159',
    save_money: '50',
    limit: 99,
    // discount: "%1=339%%2=659%%3=989%%n={per=1,off=0}%",
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W Rigid Solar Panel+4*Rigid solar mounting feet',
    pid: '7293362045120',
    varId: '42914703114432',
    old_price: '729',
    off_price: '539',
    save_money: '190',
    limit: 99,
    // tips: "*This item excludes free shipping.",
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*100W Flexible Solar Panel',
    pid: '7293362110656',
    varId: '42914703409344',
    old_price: '139',
    off_price: '109',
    save_money: '30',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }]
};
exports.BatteryMap = {
  6: [{
    name: '2kWh LFP Battery + Mounting strap + Battery Cable',
    pid: '7293361914048',
    varId: '42943958024384',
    off_price: '1548',
    old_price: '2048',
    save_money: '500',
    capacity: '2-1',
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5kWh LFP Battery + Mounting strap + Battery Cable',
    pid: '7293361914048',
    varId: '42943973818560',
    off_price: '3348',
    old_price: '4248',
    save_money: '900',
    capacity: '5-1',
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }
  // {
  //     name: '2kWh LFP Battery',
  //     pid: '7293361914048',
  //     varId: '42914701967552',
  //     off_price: '1499',
  //     old_price: '1999',
  //     save_money: '500',
  //     capacity: 2,
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: '5kWh LFP Battery',
  //     pid: '7293361914048',
  //     varId: '42914702000320',
  //     off_price: '3299',
  //     old_price: '4199',
  //     save_money: '900',
  //     capacity: 5,
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  // {
  //     name: '2kWh LFP Battery + Mounting Strap',
  //     pid: '7293361914048',
  //     varId: '42943958024384',
  //     off_price: '1548',
  //     old_price: '2048',
  //     save_money: '500',
  //     capacity: '2-1',
  //     imgSrc: '/img/mm100/preview/battery-2kw.jpg',
  // },
  // {
  //     name: '5kWh LFP Battery + Mounting Strap',
  //     pid: '7293361914048',
  //     varId: '42943973818560',
  //     off_price: '3348',
  //     old_price: '4248',
  //     save_money: '900',
  //     capacity: '5-1',
  //     imgSrc: '/img/mm100/preview/battery-5kw.jpg',
  // },
  ]
};

// exports.InstallationMap = {
//     6: {
//         pid: '7293362143424',
//         varId: '42914703442112',
//         off_price: '0',
//         old_price: '0',
//         save_money: '0',
//     },
// };

exports.ConsoleMap = {
  6: [{
    name: 'EcoFlow Power Kits Console',
    pid: '7310996439232',
    varId: '42984337735872',
    off_price: '329',
    old_price: '329',
    limit: 1,
    // save_money: '599',
    prdType: 'console',
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};
exports.ShopifyUrl = 'https://uk.ecoflow.com/';